import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQSchema } from "@/components/StructuredData";

interface RegionalFAQSectionProps {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
  title?: string;
  subtitle?: string;
}

export const RegionalFAQSection = ({ faqs, title = "Häufig gestellte Fragen", subtitle = "Antworten auf die wichtigsten Fragen zu unseren Leistungen in der Rhein-Neckar-Region" }: RegionalFAQSectionProps) => {
  return (
    <section className="section-padding bg-gradient-to-b from-primary/5 to-background">
      <div className="container-custom">
        <FAQSchema faqs={faqs} />
        
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {subtitle}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="bg-background/50 backdrop-blur-xs rounded-2xl border border-primary/20 px-6 data-[state=open]:shadow-lg data-[state=open]:border-primary/30 transition-all"
              >
                <AccordionTrigger className="hover:no-underline py-6 text-left">
                  <h3 className="font-semibold text-lg pr-4">{faq.question}</h3>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
